import { GridColDef } from "@mui/x-data-grid";

import { FilterAll } from "./common";
import { ICustomPanel } from "./panel";

export interface IDesignColDef extends Omit<GridColDef, ""> {
  field: keyof IDesign;
}

export type DesignFilter = FilterAll | DesignStatus;

export enum DesignStatus {
  PUBLISHED = "Published",
  UNPUBLISHED = "Unpublished",
}

export enum CnvStatus {
  YES = "Y",
  NO = "N",
  NOT_AVAILABLE = "A",
  YES_NO = "X",
}

export enum CnvToggleStatus {
  IMMUTABLE_NO = "A",
  IMMUTABLE_YES = "Y",
  MUTABLE = "X",
}

export enum Workflow {
  VARITANT = "VariantPlex",
  FUSION = "FusionPlex",
  LIQUID = "LiquidPlex",
  IMMUNOVERSE = "immunoverse",
}

export enum PlatformType {
  ILLUMINA = "Illumina",
  IONTORRENT = "IonTorrent",
}

export enum DesignType {
  CATALOG_PANEL = "catalog_panel",
  GENE_MODULE = "gene_module",
  SUGGESTED_PANEL = "suggested_panel",
}

export interface ICatalogDetailFromContentful {
  designId: number;
  description?: string;
  specs?: {
    annotation?: string;
    field: string;
    label: string;
    value?: string;
  }[];
  footnotes: Array<{
    key: string;
    annotation: string;
    value: string;
  }>;
}

export interface IDesign {
  id: number;
  name: string;
  workflow: number;
  designSpecification?: ICatalogDetailFromContentful | null;
  status?: DesignStatus;
  modifiedAt?: string;
  tissueType?: string;
  moleculeType?: string;
  createdAt: string;
  designType: DesignType;
  diseaseType: number[];
  platformType: PlatformType[];
  mpId?: string;
  numberGenes?: number;
  totalBases?: number;
  readsRounded: number;
  readsRecommended?: number;
  numberPrimerPairs?: number;
  hasSnpId?: boolean;
  hasMsi?: boolean;
  hasTmb?: boolean;
  snpIdToggle?: CnvToggleStatus;
  msiToggle?: CnvToggleStatus;
  cnvToggle: boolean;
  coveredGenes: string[];
  extraGenes: string[];
  uncoveredGenes: string[];
  numberCoveredGenes: number;
  numberCoveredPartnerGenes: number;
  numberCoveredPartnerTargets: number;
  numberCoveredTargetGenes: number;
  numberExtraGenes: number;
  numberUncoveredGenes: number;
  coveredTargetGenes: string[];
  coveredPartnerGenes: string[];
  coveredPartnerTargets: {
    [key: string]: string[];
  };
  panelspresent: Array<{
    cnv: boolean;
    customPanel: number;
    design: number;
    tmb: boolean;
  }>;
  // It will be used only on front-end to identify if a panel is quoted
  requisitionId?: string;
  uploadedAt?: string;
  version?: number;
  draftSaved?: ICustomPanel;
}

export interface IDisease {
  id: number;
  name: string;
}
